export enum SponsorTypeCodes {
  SELF = 1,
  COMPANY = 2,
  SUPPLIER = 3,
  SUB_CONTRACTOR = 4,
}
